<template>
  <div class="section-container">
    <div class="main-container">
      <div class="type-wrap">
        <router-link to="/" class="home-page">首页></router-link>
        <span class="type-name">企业文化</span>
      </div>
      <div class="page__title">
        <h2 class="large__title">企业文化</h2>
        <h4 class="small__title square">CORPORATE CULTURE</h4>
      </div>
      <div class="content">
        <div class="media" v-for="(item, index) in info" @click="onClick(index)" :key="item.id">
          <div class="media-left">
            <img :src="item.bannerUrl" class="media-object">
          </div>
          <div class="media-body">
            <h3 class="media-heading">{{item.title}}</h3>
            <p class="txt">{{item.summary}}</p>
            <div class="date">发布日期：{{item.addDate}}</div>
          </div>
        </div>
      </div>
      <div class="pagebar-box">
        <pagination
          :count="count"
          :page-size="pageSize"
          :current-page="currentPage"
          @on-page-click="onPageClick" />
      </div>
    </div>
    <div class="page-caption">
      <div class="point"></div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import Pagination from '@/components/combo/pagination'

  export default {
    components: {
      Pagination
    },
    data () {
      return {
        info: {},
        page: {},
        pageSize: 3,
        count: 1,
        currentPage: 1
      }
    },
    created () {
      this.aid = this.$route.params.id
      this._fetchData()
    },
    methods: {
      _fetchData (currentPage) {
        let vm = this
        this.$http({
          url: '/getCorporateCultureArticles.jhtml',
          data: {
            articleId: this.aid,
            isPage: 'y',
            pageSize: this.pageSize,
            pageNumber: currentPage || 1
          },
          done (info, page) {
            vm.currentPage = currentPage
            vm.info = info || {}
            vm.page = page || {}
            vm.count = page.count
          }
        })
      },
      onClick (index) {
        let item = this.info[index]
        window.open(`/about/culture/${item.id}`)
        // this.$router.push(`/about/culture/${item.id}`)
      },
      onPageClick (currentPage) {
        this._fetchData(currentPage)
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .main-container
    padding-top 46px
  .content
    margin 30px auto 0
    .media
      padding 17px 27px 22px
      border-radius 5px
      background-color #fff
      border 1px solid rgb(226, 228, 230)
      &:hover
        box-shadow 0 0px 21px 0 rgb(175, 183, 192)
        cursor pointer
      .media-left
        padding-right 27px
        border-radius 5px
        >img
          display block
          width 315px
          height 200px
      .media-body
        font-size 14px
        color rgb(51, 51, 51)
        .media-heading
          width 744px
          height 30px
          margin-bottom 25px
          font-size 28px
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
        .txt
          height 85px
          overflow hidden
          line-height 24px
          margin-bottom 40px
        .date
          color rgb(153, 153, 153)
  .pagebar-box
    margin 60px 0 40px

  .type-wrap
    position absolute
    top 24px
    font-size 12px
    span
      color #333
    .type-name
      font-family MicrosoftYaHei
      color #2b9efc
    .home-page
      text-decoration none
      color #333
</style>



// WEBPACK FOOTER //
// culture.vue?7edb2d2c